module.exports = __webpack_public_path__ + "static/media/txt.e2b1333b.svg";